import React from 'react'

import Routing from 'routing'
import { InternationalizationProvider } from 'providers/intl'
import { AuthProvider } from 'providers/auth'
import { ProfileProvider } from 'providers/profile'
import { CountriesProvider } from 'providers/countries'
import { SocketProvider } from './providers/socket'
import { MySiteProvider } from './providers/mySiteProvider'
import { HabitatProvider } from './providers/HabitatContext'
import { Monitor } from '@mui/icons-material'
import { MonitoringProvider } from 'providers/monitoring'

const App = () => {
  return (
    <InternationalizationProvider>
      <CountriesProvider>
        <AuthProvider>
          <ProfileProvider>
            <SocketProvider>
              <MySiteProvider>
                <HabitatProvider>
                  <MonitoringProvider>
                  <Routing />
                  </MonitoringProvider>
                </HabitatProvider>
              </MySiteProvider>
            </SocketProvider>
          </ProfileProvider>
        </AuthProvider>
      </CountriesProvider>
    </InternationalizationProvider>
  )
}
export default App
